"use client";

/**
 * CollabV3DateText 컴포넌트
 * @description 날짜 한 조각 — 표시 시간대(`CollabV3TimeZone`)로 찍는다. 서버 컴포넌트(스레드 글 등)
 *   안에 날짜만 끼울 때 쓴다.
 * @example <CollabV3DateText iso={item.createdAt} kind="short" />
 */
import { memo, useMemo } from "react";

import type { CollabV3DateTextProps } from "./CollabV3Detail.types";
import { useCollabV3TimeZone } from "./CollabV3TimeZone";

import {
  formatDay,
  formatDayTime,
  formatShortDay,
} from "../../utils/collabV3Format";

const FORMATTERS = {
  day: formatDay,
  short: formatShortDay,
  dayTime: formatDayTime,
} as const;

const CollabV3DateText = memo<CollabV3DateTextProps>(({ iso, kind }) => {
  const timeZone = useCollabV3TimeZone();
  const text = useMemo(
    () => FORMATTERS[kind](iso, timeZone),
    [iso, kind, timeZone],
  );
  return <time dateTime={iso}>{text}</time>;
});

CollabV3DateText.displayName = "CollabV3DateText";

export default CollabV3DateText;
